
export class ReportPdcProviderRequest {
  public userName: string;
  public collectionId: number;
  public providerName?: string;
  public providerTaxId?: string;
  public providerNPI?: string;
  public providerSearchType?: string;
}